module.exports = __webpack_public_path__ + "static/media/logo-conlicitacao.465791c8.svg";